/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Script } from "gatsby"

function SEO({ title, children }: any) {
  return (
    <>
      <title>{`${title} | Capitaria`}</title>
      <meta name="description" content="Comienza a hacer Trading con más de 450 instrumentos financieros. Capitaria te ofrece: Seminarios, Webinars, Cursos y Talleres. 14 años de experiencia." />
      <meta property="og:title" content={title} />
      <meta property="og:description" content="Comienza a hacer Trading con más de 450 instrumentos financieros. Capitaria te ofrece: Seminarios, Webinars, Cursos y Talleres. 14 años de experiencia." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.capitaria.com/opengraph.jpg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content="Capitaria" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content="Comienza a hacer Trading con más de 450 instrumentos financieros. Capitaria te ofrece: Seminarios, Webinars, Cursos y Talleres. 14 años de experiencia." />
      <meta name="google-site-verification" content="nzowlMm2vJJHnu0WQv7Twpyw0ok1K1e6ilYLMiABymM" />
      <Script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=a5018f0e-19a7-483a-847e-5845e6a26ce8" />
      <Script id="hotjar">
        {`
          <!--  Hotjar Tracking Code for https://www.capitaria.com -->
          (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:1838349,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      {children}
    </>
  )
}

SEO.defaultProps = {}

SEO.propTypes = {
  title: PropTypes.string.isRequired,
}

export default SEO
